import { types } from './actions';

const initialState = {
  isFetchingTasks: false,
  isTaskOverviewModalOpen: false,
  openTasks: [],
  openTaskCount: 0,
  page: 1,
  pageSize: 10,
  quoteNumberWithRevision: '',
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.CLOSE_TASK_OVERVIEW_MODAL:
      return initialState;
    case types.FETCH_TASKS_ERROR:
      return initialState;
    case types.FETCH_TASKS_REQUEST:
      return {
        ...state,
        isFetchingTasks: true,
      };
    case types.FETCH_TASKS_SUCCESS:
      return {
        ...state,
        isFetchingTasks: false,
        openTaskCount: payload.openTaskCount,
        openTasks: payload.openTasks,
      };
    case types.TASKS_PAGINATE:
      return {
        ...state,
        page: payload.pageNumber,
      };
    case types.OPEN_TASK_OVERVIEW_MODAL:
      return {
        ...state,
        isTaskOverviewModalOpen: true,
        page: 1,
        quoteNumberWithRevision: payload.quoteNumberWithRevision,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.common.modals.taskOverviewModal;

export const getIsModalOpen = (state) =>
  getScope(state).isTaskOverviewModalOpen;

export const getIsFetchingTasks = (state) => getScope(state).isFetchingTasks;

export const getOpenTaskCount = (state) => getScope(state).openTaskCount;

export const getOpenTasks = (state) => getScope(state).openTasks;

export const getPage = (state) => getScope(state).page;

export const getPageSize = (state) => getScope(state).pageSize;

export const getQuoteNumberWithRevision = (state) =>
  getScope(state).quoteNumberWithRevision;
